import React from 'react';
import Grid from "@material-ui/core/Grid/Grid";
import Typography from "@material-ui/core/Typography/Typography";
import {setStore} from "trim-redux";
import {withStyles} from "@material-ui/core";
import {Styles} from "../../../../../config/design/styles";
import SubTitle from "../../../../components/elements/SubTitle";
import axios from "axios";
import {defaultVariabls} from "../../../../../config/index";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import {Translate} from "../../../../../config/Translate";
import Button from "@material-ui/core/Button/Button";
import {currencySymbol, price} from "../../../../../config/values";
import ChevronLeftRoundedIcon from '@material-ui/icons/ChevronLeftRounded';
import {Link} from "react-router-dom";
import Divider from "@material-ui/core/Divider/Divider";
import VisibilityRoundedIcon from '@material-ui/icons/VisibilityRounded';
import IconButton from "@material-ui/core/IconButton/IconButton";
import clsx from "clsx";
class ToDos extends React.Component {
    state = {
        products: null,
        revisions: null,
        shops: null,
        verification_details: null,
        wallets: null,
        reviews: null,
        loading:true,
    };
    componentDidMount(){
        this.loadData();
    }
    async componentDidUpdate(newProps){
        if(this.state.beginDate !== this.props.beginDate){
            await this.setState({
                beginDate: this.props.beginDate
            })
            await this.loadData();
        }
        if(this.state.endDate !== this.props.endDate){
            await this.setState({
                endDate: this.props.endDate
            })
            await this.loadData();
        }
    }
    async loadData(){
        let {beginDate,endDate} = this.state;
        if((!!beginDate && !!endDate) || (!beginDate && !endDate)){
            this.setState({
                loading:true,
            });
            let loginToken = localStorage.getItem('ACT');
            if(loginToken !== null){
                let config = {
                    headers: {
                        Accept: 'application/json',
                        Authorization: `Bearer ${loginToken}`
                    }
                };
                await axios.get(`${defaultVariabls.url}/analytics/todos`, config)
                    .then(response => {
                        this.setState({
                            products: response.data.products,
                            revisions: response.data.revisions,
                            shops:  response.data.shops,
                            verification_details: response.data.verification_details,
                            wallets:  response.data.wallets,
                            reviews:  response.data.reviews,
                            loading:false,
                        })
                    }).catch(error => {
                        console.log(error.response)
                        this.setState({
                            loading:false
                        })
                    })
            }else {
                setStore({
                    isAuth : false,
                    user : null,
                    loading:false
                });
                this.setState({
                    loading:false
                })
            }
        }
    }
    classes = this.props.classes;
    render(){
        let {products,revisions,shops,verification_details,reviews,wallets,loading} = this.state;
        return (
            <Grid container spacing={2} direction="row" justify="center" alignItems="center">
                <Grid item xs={12} sm={6} md>
                    <Link to={'/manage/products'} className="todo_link">
                        <Grid container  style={{backgroundColor: "#fff",position:"relative"}} direction="row" alignItems="center" justify="center" className={clsx(this.classes.GridAsaPaperBaby,'grid-parent')}>
                            {
                                products > 0 && <span className="ripple"></span>
                            }
                            <Grid item xs={11}>
                            <SubTitle>
                                {Translate.book_confirmation_requests}
                                </SubTitle>
                            </Grid>
                            <Grid item xs={12}>
                            <Typography style={{textAlign:"center",marginTop:10,marginBottom:15}} className={this.classes.AnalyticsResult} >{loading ? <CircularProgress size={25}/> : products}</Typography>
                            </Grid>
                        </Grid>
                    </Link>
                </Grid>
                <Grid item xs={12} sm={6} md>
                    <Link to="/manage/revisions" className="todo_link">
                        <Grid container  style={{backgroundColor: "#fff",position:"relative"}} direction="row" alignItems="center" justify="center" className={clsx(this.classes.GridAsaPaperBaby,'grid-parent')}>
                            {
                                revisions > 0 && <span className="ripple"></span>
                            }
                            <Grid item xs={11}>
                                <SubTitle>
                                    {Translate.book_revision_requests}
                                </SubTitle>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography style={{textAlign:"center",marginTop:10,marginBottom:15}} className={this.classes.AnalyticsResult} >{loading ? <CircularProgress size={25}/> : revisions}</Typography>
                            </Grid>
                        </Grid>
                    </Link>

                </Grid>
                <Grid item xs={12} sm={6} md>
                    <Link to={'/manage/wallets-requests'} className="todo_link">
                    <Grid container  style={{backgroundColor: "#fff",position:"relative"}} direction="row" alignItems="center" justify="center" className={clsx(this.classes.GridAsaPaperBaby,'grid-parent')}>
                        {
                            wallets > 0 && <span className="ripple"></span>
                        }
                        <Grid item xs={11}>
                            <SubTitle>
                                {Translate.wallet_confirmation_requests}
                            </SubTitle>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography style={{textAlign:"center",marginTop:10,marginBottom:15}} className={this.classes.AnalyticsResult} >{loading ? <CircularProgress size={25}/> : wallets}</Typography>
                        </Grid>
                    </Grid>
                    </Link>
                </Grid>
                <Grid item xs={12} sm={6} md>
                    <Link to={'/manage/shops'} className="todo_link">
                        <Grid container  style={{backgroundColor: "#fff",position:"relative"}} direction="row" alignItems="center" justify="center" className={clsx(this.classes.GridAsaPaperBaby,'grid-parent')}>
                            {
                                shops > 0 && <span className="ripple"></span>
                            }
                            <Grid item xs={11}>
                                <SubTitle>
                                    {Translate.shop_confirmation_requests}

                                </SubTitle>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography style={{textAlign:"center",marginTop:10,marginBottom:15}} className={this.classes.AnalyticsResult} >{loading ? <CircularProgress size={25}/> : shops}</Typography>
                            </Grid>
                        </Grid>
                    </Link>

                </Grid>
                <Grid item xs={12} sm={6} md>
                    <Link to={'/manage/verifications'} className="todo_link">
                        <Grid container  style={{backgroundColor: "#fff",position:"relative"}} direction="row" alignItems="center" justify="center" className={clsx(this.classes.GridAsaPaperBaby,'grid-parent')}>
                            {
                                verification_details > 0 && <span className="ripple"></span>
                            }
                            <Grid item xs={11}>
                                <SubTitle >
                                    {Translate.verification_details_confirmation_requests}
                                </SubTitle>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography style={{textAlign:"center",marginTop:10,marginBottom:15}} className={this.classes.AnalyticsResult} >{loading ? <CircularProgress size={25}/> : verification_details}</Typography>
                            </Grid>
                        </Grid>
                    </Link>

                </Grid>
                <Grid item xs={12} sm={6} md>
                    <Link to={'/manage/reviews'} className="todo_link">
                        <Grid container  style={{backgroundColor: "#fff",position:"relative"}} direction="row" alignItems="center" justify="center" className={clsx(this.classes.GridAsaPaperBaby,'grid-parent')}>
                            {
                                reviews > 0 && <span className="ripple"></span>
                            }
                            <Grid item xs={11}>
                                <SubTitle>
                                    {Translate.reviews_confirmation_requests}
                                </SubTitle>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography style={{textAlign:"center",marginTop:10,marginBottom:15}} className={this.classes.AnalyticsResult} >{loading ? <CircularProgress size={25}/> : reviews}</Typography>
                            </Grid>
                        </Grid>
                    </Link>
                </Grid>
            </Grid>
        );
    }
}

export default withStyles(Styles)(ToDos);